import Vue from 'vue'
import mhComponent1 from "./mh-component-1/mh-component-1.vue";


Vue.component(mhComponent1.name, mhComponent1)
